import React from 'react'

export default function FutureMineralsRegionDetailsParagraphLoading() {
  return (
    <div className="animate-pulse">
      <div className="border-muted-300 h-16 border-2 bg-light p-4 text-white" />
      <div className="border-muted-300 border-2 border-y-0 p-4">
        <div className="bg-muted-300 mb-4 h-20 w-[120px]" />
        <div className="bg-muted-300 mb-4 h-4 w-full" />
        <div className="bg-muted-300 mb-4 h-4 w-full" />
        <div className="bg-muted-300 mb-4 h-4 w-full" />
        <div className="bg-muted-300 mb-4 h-4 w-2/3" />
      </div>
      <div className="border-muted-300 border-2 bg-light p-4">
        <div className="mb-2 font-bold">
          <div className="bg-muted-300 mb-4 h-6 w-20" />
        </div>
        <div className="bg-muted-300 my-4 h-4 w-2/3" />
        <div className="bg-muted-300 mb-4 h-4 w-2/3" />
      </div>
    </div>
  )
}
